module.exports = __webpack_public_path__ + "img/card.dc87d104.svg";